import React from "react";

import styled from "@emotion/styled";

const Container = styled.div`
    scroll-margin-top: 80px;

    ::-webkit-full-page-media,
    :future,
    :root .safari_only {
        padding-top: 80px;
        margin-top: -80px;
    }
    @media not all and (min-resolution: 0.001dpcm) {
        @supports (-webkit-appearance: none) {
            padding-top: 80px;
            margin-top: -80px;
        }
    }
`;

const JumpMark = ({ jumpMark }) => {
    return <Container id={jumpMark} />;
};

export default JumpMark;
